import { useContext } from 'react';
import FormatDate from '../../Util/FormatDate';
import { StoreContext } from '../../Store';
import { QAStoreContext } from './QAStore';
import SimpleTable from '../../SimpleTable';
import { isDirftNutriciaEntryPortCombinationInvalid } from './utils';

const DataCheck = ({ portID, portModelID, entryPort, exitPort, setIsDataCheckValid }) => {
  const store = useContext(StoreContext);
  const qaStore = useContext(QAStoreContext);

  const config = qaStore.currentConfig[0];
  const itemTotals = qaStore.itemTotals[0];
  const consigneeData = qaStore.consigneeData[0];
  const { itemRows, uniqueInvoiceHeaders } = itemTotals;

  const selectedRouteID = store.directionSelected[0];
  const availableRoutes = store.movementOptions[0];
  const loadingDate = store.date[0];
  const portsModalOptions = store.portsModalOptions[0];

  const getValueFromID = (options, id) => {
    const selectedOption = options?.find((option) => parseInt(option.id) === parseInt(id));
    return selectedOption ? selectedOption.data : null;
  };

  const entryPortNutriciaDirftError = isDirftNutriciaEntryPortCombinationInvalid(
    entryPort,
    consigneeData?.eori,
    !!config.visibleFields.entryPort
  );

  const validRoute = selectedRouteID && availableRoutes;
  const validPortModel = portID > 0 && portModelID > 0 && portsModalOptions;
  const validPorts = !((config.visibleFields.entryPort && !entryPort) || (config.visibleFields.exitPort && !exitPort));

  //convert the value to boolean to ensure consistency with the other components on the QA tab
  setIsDataCheckValid(!!(validRoute && loadingDate && validPorts && validPortModel && !entryPortNutriciaDirftError));

  const tableData = {
    headings: [
      {
        label: 'Route',
        key: 'route',
        error: !validRoute,
        valueCellId: 'qa-data-check-route-value',
      },
      {
        label: 'Loading Date',
        key: 'loadingDate',
        error: !loadingDate,
        valueCellId: 'qa-data-check-loading-date-value',
      },
      {
        label: 'Exit Port',
        key: 'exitPort',
        error: !exitPort,
        hide: !config.visibleFields.exitPort,
        valueCellId: 'qa-data-check-exit-port-value',
      },
      {
        label: 'Entry Port',
        key: 'entryPort',
        error: entryPortNutriciaDirftError,
        hide: !config.visibleFields.entryPort,
        valueCellId: 'qa-data-check-entry-port-value',
      },
      {
        label: 'Port Model',
        key: 'portModel',
        error: !validPortModel,
        valueCellId: 'qa-data-check-port-model-value',
      },
      {
        label: 'Invoice Lines',
        key: 'invoiceLines',
        error: !entryPort,
        hide: !config.visibleFields.invoiceLines,
        valueCellId: 'qa-data-check-invoice-lines-value',
      },
      {
        label: 'Invoice Headers',
        key: 'invoiceHeaders',
        hide: !config.visibleFields.invoiceHeaders,
        valueCellId: 'qa-data-check-invoice-headers-value',
      },
    ],
    values: [
      {
        id: 'data-check-table-values',
        route: validRoute && getValueFromID(availableRoutes, selectedRouteID),
        loadingDate: loadingDate && FormatDate(loadingDate),
        exitPort,
        entryPort,
        portModel: validPortModel && portID > 0 && getValueFromID(portsModalOptions, portModelID),
        invoiceLines: itemRows,
        invoiceHeaders: uniqueInvoiceHeaders,
      },
    ],
  };

  return <SimpleTable data={tableData} isHeaderRow={false} />;
};

export default DataCheck;
